// Models
import { createAssessmentGeneralProofStoreDefaultModel } from './general-proof.store'
import { createAssessmentRelevantProofStoreDefaultModel } from './relevant-proof.store'
import { createAssessmentCompetencyUnitStoreDefaultModel } from './competency-unit.store'
import { createAssessmentAdministrativeProofStoreDefaultModel } from './administrative-proof.store'

const assessmentRegistrationModels = {
  assessmentGeneralProof: createAssessmentGeneralProofStoreDefaultModel(),
  assessmentRelevantProof: createAssessmentRelevantProofStoreDefaultModel(),
  assessmentCompetencyUnit: createAssessmentCompetencyUnitStoreDefaultModel(),
  assessmentAdministrativeProof: createAssessmentAdministrativeProofStoreDefaultModel(),
}

export { assessmentRegistrationModels }
